// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"135":"rich-text","577":"json-editor"}[chunkId] || chunkId) + "." + {"135":"36dd8d0d","577":"a0a3833c","753":"7fdb6ff2","761":"322877e7"}[chunkId] + ".chunk.js";
};